import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_TOURNAMENT_IS_APPLIED } from 'api/notificationManager/methods';

export default class TournamentCheckIsAppliedRequest extends WsBaseRequest {
  constructor(tournamentID: number) {
    super(API_TOURNAMENT_IS_APPLIED, { id: tournamentID });
  }
}
